export enum Events {
	UPDATE_GRAPH_VISIBILITY_STATE = 'UPDATE_GRAPH_VISIBILITY_STATE',
	UPDATE_GRAPH_MANAGER_TABLE = 'UPDATE_GRAPH_MANAGER_TABLE',
	TABLE_COLUMNS_DATA = 'TABLE_COLUMNS_DATA',
	SLOW_API_WARNING = 'SLOW_API_WARNING',
}
